// Driver: today's route, stop by stop.
import { myRoutes, markStop, todayIST } from '../lib/api.js';
import { fmtClock, navLink } from '../lib/planner.js';
import { $, $$, esc, busy, toast, makeMap, numberIcon, statusChip, L } from '../lib/ui.js';
import { AppLauncher } from '@capacitor/app-launcher';

export async function renderMyRoute(app, { profile, isNative }) {
  app.innerHTML = '<div class="side" id="side"></div><div class="map" id="map"></div>';
  const map = makeMap($('#map'));
  const layer = L.layerGroup().addTo(map);
  const side = $('#side');
  let routes = [];

  async function load() {
    side.innerHTML = '<p class="pad">Loading your route…</p>';
    try {
      routes = (await myRoutes(todayIST())).filter(r => r.driver_id === profile.id);
    } catch (e) { side.innerHTML = `<div class="err">${esc(e.message)}<br><button id="retry">Retry</button></div>`; $('#retry').onclick = load; return; }
    render();
  }

  function render() {
    layer.clearLayers();
    if (!routes.length) {
      side.innerHTML = `<div class="card"><p>No route assigned to you for today (${esc(todayIST())}).</p><p class="hint" style="padding:6px 0 0">Pull to refresh or tap below once the dispatcher publishes.</p><button id="retry" class="big">Refresh</button></div>`;
      $('#retry').onclick = load;
      return;
    }
    const pts = [];
    let html = '<div class="bar"><button id="retry">Refresh</button></div>';
    routes.forEach(r => {
      if (r.geometry) layer.addLayer(L.geoJSON(r.geometry, { style: { color: r.color, weight: 5, opacity: 0.8 } }));
      const next = r.stops.find(s => s.status === 'pending');
      const done = r.stops.filter(s => s.status !== 'pending').length;
      html += `<div class="summary" style="border-left:6px solid ${r.color}">🚚 <b>Van ${r.van_no}</b> · ${done}/${r.stops.length} done · back ~${fmtClock(r.back_by_min ?? 0)}</div>`;
      r.stops.forEach(s => {
        const loc = s.location || {};
        if (Number.isFinite(loc.lat)) {
          pts.push([loc.lat, loc.lng]);
          const col = s.status === 'delivered' ? '#2e8b57' : s.status === 'failed' ? '#b91c1c' : r.color;
          layer.addLayer(L.marker([loc.lat, loc.lng], { icon: numberIcon(s.seq, col) }).bindPopup(`<b>${esc(loc.name)}</b><br>${esc(loc.address)}`));
        }
        const isNext = next && s.id === next.id;
        html += `<div class="row ${isNext ? 'next' : ''} ${s.status !== 'pending' ? 'done' : ''}">
          <div class="badge" style="background:${r.color}">${s.seq}</div>
          <div class="grow">
            <div class="name">${esc(loc.name)} ${s.status !== 'pending' ? statusChip(s.status) : ''}${s.early ? ' <span class="chip skipped">early</span>' : ''}</div>
            <div class="addr">${esc(loc.address)}</div>
            <div><span class="eta">ETA ~${fmtClock(s.eta_min ?? 0)}</span>${s.volume > 1 ? ` · vol ${s.volume}` : ''}${s.note ? ` · “${esc(s.note)}”` : ''}</div>
            ${s.status === 'pending' ? `<div class="ctl">
              <a class="btn ${isNext ? 'primary' : ''}" href="${navLink(loc.lat, loc.lng)}" target="_blank" rel="noopener">Navigate</a>
              <button data-ok="${s.id}">Delivered</button>
              <button class="warn" data-fail="${s.id}">Failed</button>
            </div>` : ''}
          </div></div>`;
      });
    });
    side.innerHTML = html;
    if (pts.length) { map.invalidateSize(); map.fitBounds(L.featureGroup(layer.getLayers()).getBounds().pad(0.1)); }
    $('#retry').onclick = load;
    // In the Android app, hand navigation links to the Google Maps app instead of the WebView.
    if (isNative) $$('a.btn[target=_blank]', side).forEach(a => a.onclick = e => { e.preventDefault(); AppLauncher.openUrl({ url: a.href }); });
    $$('[data-ok]', side).forEach(b => b.onclick = () => update(b, b.dataset.ok, 'delivered', null));
    $$('[data-fail]', side).forEach(b => b.onclick = () => {
      const note = prompt('Why could it not be delivered? (shop closed, refused, …)');
      if (note !== null) update(b, b.dataset.fail, 'failed', note);
    });
  }

  function update(btn, id, status, note) {
    busy(btn, async () => {
      const saved = await markStop(id, status, note);
      for (const r of routes) { const s = r.stops.find(x => x.id === id); if (s) Object.assign(s, saved); }
      toast(status === 'delivered' ? 'Marked delivered ✓' : 'Marked failed');
      render();
    }).catch(() => {});
  }

  await load();
  return () => map.destroy();
}
